import { render, staticRenderFns } from "./WoundEditPhoto.vue?vue&type=template&id=f638956c&"
import script from "./WoundEditPhoto.vue?vue&type=script&lang=js&"
export * from "./WoundEditPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports